import { Link, useForm, usePage } from "@inertiajs/react";
import { useState } from "react";
import Footer from "./Component/Footer";
import Header from "./Component/Header";

export default function SignUp() {
    const { flash } = usePage().props;
    const [notification, setNotification] = useState(null);
    const { data, setData, post, processing, errors, reset } = useForm({
        name: "",
        email: "",
        phone: "",
        password: "",
        password_confirmation: "",
    });

    const submit = (e) => {
        e.preventDefault();

        setNotification(null);

        post("/sign-up", {
            onSuccess: () => {
                const message = "Pendaftaran berhasil. Akun Anda sudah dibuat dan sedang menunggu persetujuan admin.";
                setNotification({
                    type: "success",
                    message,
                });
                window.alert(message);
            },
            onError: () => {
                const message = "Pendaftaran gagal. Periksa kembali formulir lalu coba lagi.";
                setNotification({
                    type: "error",
                    message,
                });
                window.alert(message);
            },
            onFinish: () => reset("password", "password_confirmation"),
        });
    };

    return (
        <>
            <Header />
            <main id="content" className="max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto py-8 sm:py-12">
                <div className="max-w-xl mx-auto rounded-xl border border-card-line bg-card p-6 sm:p-8 shadow-2xs">
                    <div className="mb-6">
                        <h1 className="text-xl font-semibold text-foreground">Daftar Reseller</h1>
                        <p className="mt-1 text-sm text-muted-foreground-1">
                            Isi data berikut untuk membuat akun reseller.
                        </p>
                    </div>

                    {(notification || flash?.error) && (
                        <div
                            className={`mb-4 rounded-lg px-3 py-2 text-sm ${
                                notification?.type === "success"
                                    ? "border border-green-200 bg-green-50 text-green-700"
                                    : "border border-red-200 bg-red-50 text-red-700"
                            }`}
                        >
                            {notification?.message ?? flash.error}
                        </div>
                    )}

                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label htmlFor="signup-name" className="mb-1.5 block text-sm font-medium text-foreground">
                                Nama
                            </label>
                            <input
                                id="signup-name"
                                type="text"
                                value={data.name}
                                onChange={(e) => setData("name", e.target.value)}
                                className="py-2.5 px-3 block w-full rounded-lg border border-layer-line bg-layer text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                placeholder="Nama lengkap Anda"
                            />
                            {errors.name && <p className="mt-1 text-xs text-red-600">{errors.name}</p>}
                        </div>

                        <div>
                            <label htmlFor="signup-email" className="mb-1.5 block text-sm font-medium text-foreground">
                                Email
                            </label>
                            <input
                                id="signup-email"
                                type="email"
                                value={data.email}
                                onChange={(e) => setData("email", e.target.value)}
                                className="py-2.5 px-3 block w-full rounded-lg border border-layer-line bg-layer text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                placeholder="you@example.com"
                            />
                            {errors.email && <p className="mt-1 text-xs text-red-600">{errors.email}</p>}
                        </div>

                        <div>
                            <label htmlFor="signup-phone" className="mb-1.5 block text-sm font-medium text-foreground">
                                Nomor Telepon
                            </label>
                            <input
                                id="signup-phone"
                                type="text"
                                value={data.phone}
                                onChange={(e) => setData("phone", e.target.value)}
                                className="py-2.5 px-3 block w-full rounded-lg border border-layer-line bg-layer text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                placeholder="Contoh: 08123456789"
                            />
                            {errors.phone && <p className="mt-1 text-xs text-red-600">{errors.phone}</p>}
                        </div>

                        <div>
                            <label htmlFor="signup-password" className="mb-1.5 block text-sm font-medium text-foreground">
                                Kata Sandi
                            </label>
                            <input
                                id="signup-password"
                                type="password"
                                value={data.password}
                                onChange={(e) => setData("password", e.target.value)}
                                className="py-2.5 px-3 block w-full rounded-lg border border-layer-line bg-layer text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                placeholder="Minimal 8 karakter"
                            />
                            {errors.password && <p className="mt-1 text-xs text-red-600">{errors.password}</p>}
                        </div>

                        <div>
                            <label htmlFor="signup-password-confirmation" className="mb-1.5 block text-sm font-medium text-foreground">
                                Konfirmasi Kata Sandi
                            </label>
                            <input
                                id="signup-password-confirmation"
                                type="password"
                                value={data.password_confirmation}
                                onChange={(e) => setData("password_confirmation", e.target.value)}
                                className="py-2.5 px-3 block w-full rounded-lg border border-layer-line bg-layer text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                placeholder="Ulangi kata sandi"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={processing}
                            className="w-full inline-flex justify-center items-center rounded-lg border border-primary-line bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground hover:bg-primary-hover disabled:opacity-50 disabled:pointer-events-none"
                        >
                            {processing ? "Sedang membuat akun..." : "Buat akun"}
                        </button>
                    </form>

                    <p className="mt-4 text-sm text-muted-foreground-1">
                        Sudah punya akun?{" "}
                        <Link href="/login" className="font-medium text-primary hover:underline">
                            Masuk
                        </Link>
                    </p>
                </div>
            </main>
            <Footer />
        </>
    );
}
